import type { Order } from "../../../../../../../services";

const cellProcessing = (item?: Order.Model) => {
	const callStatus = item?.executorCallStatus;

	const content: string =
		callStatus?.status !== "need_call"
			? callStatus?.metadata?.callerCallSign ??
			  callStatus?.user?.data?.callSign ??
			  ""
			: "";

	let backgroundColor: string | undefined;
	switch (callStatus?.status) {
		case "need_call":
			backgroundColor = "#ADD7E7";
			break;
		case "called":
			backgroundColor = "#007F01";
			break;
		case "calling":
			backgroundColor = "#FFA500";
			break;
		default:
			backgroundColor = undefined;
			break;
	}

	return { content, backgroundColor };
};

export default cellProcessing;
